<template>
  <div class="axj-main-body">
    <div class="axj-main-body-body">
      <router-view/>
    </div>
  </div>
</template>

<script>
export default {
  name: "axj-main-body",
}
</script>

<style scoped lang="scss">
.axj-main-body{
  width: 981.75px;
  margin: 0 auto;
  min-height: 100px;
  .axj-main-body-body{
    min-height: 100px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/axj-main/component/axj-main-body/index.vue